import React, { useEffect, useState } from "react";
import "../style.scss";
import { isAuthenticated } from "../../../auth";

const PlannerExerciseView = (props) => {

  const {user, token} = isAuthenticated();
  const [workoutContent, setWorkoutContent] = useState("");
  const [currentVideo, setCurrentVideo] = useState(0);
  const [muscles, setMuscles] = useState({
    primary: "",
    secondary: ""
  });

  const [isOptionalContentEnabled, setOptionalContentEnabled] = useState(false);
  const [selectedOptionalExerciseIndex, setSelectedOptionalExerciseIndex] = useState(0);

  const toggleOptionalContentView = () => {
    setOptionalContentEnabled(!isOptionalContentEnabled)
  }

  const handleSelectOptionalExerciseIndex = (index) => {
    setSelectedOptionalExerciseIndex(index)
  }

  useEffect(() => {
    setWorkoutContent(props.contentInfo);
    {console.log(props)}
  },[props])

  return(
    <div className="w-full h-full">
      <div className="w-full h-full no-scroll-bar" style={{padding:"12px", paddingBottom:"140px", overflowY:"auto"}}>
        {
          isOptionalContentEnabled && selectedOptionalExerciseIndex != -1 ? (
            <iframe className="exercise-video-container" style={{height:"200px", borderRadius:"20px"}} src={workoutContent && workoutContent.optionalExercises[selectedOptionalExerciseIndex].fullContent.videoList && workoutContent.optionalExercises[selectedOptionalExerciseIndex].fullContent.videoList.length && workoutContent.optionalExercises[selectedOptionalExerciseIndex].fullContent.videoList[0].link}/>
          ) : (
            <iframe className="exercise-video-container" style={{height:"200px", borderRadius:"20px"}} src={workoutContent && workoutContent.fullContent.videoList && workoutContent.fullContent.videoList.length && currentVideo > -1 && workoutContent.fullContent.videoList[currentVideo].link}/>
          )
        }
        {
          isOptionalContentEnabled && selectedOptionalExerciseIndex != -1 ? (
            <div className="w-full">
              <div className="d-flex p-t-12 p-b-12 m-b-12 space-between" style={{borderBottom:"1px solid #e0e0e0"}}>
                <p className='fs-16 color-dark-blue font-weight-700 flex-item' style={{width:"60%"}}>{workoutContent.optionalExercises[selectedOptionalExerciseIndex].fullContent.videoList[0].title}</p>
              </div>
              {
                workoutContent  && workoutContent.optionalExercises[selectedOptionalExerciseIndex].parameter && workoutContent.optionalExercises[selectedOptionalExerciseIndex].parameter.set && workoutContent.optionalExercises[selectedOptionalExerciseIndex].parameter.set.length > 0 && (
                  <div className="w-full">
                    <p className="flex-item font-weight-600 color-red m-b-8">Set/Reps</p>
                    <div className="d-flex-wrap space-between">
                      {
                        workoutContent.parameter.set.map((data,index) => {
                          return(
                            <div className="planner-set-reps-container d-flex m-b-12">
                              <div className="d-flex planner-set-container p-l-12 p-r-12 h-full">
                                <p className="flex-item color-white">Set {index + 1}</p>
                              </div>
                              <div className="d-flex planner-reps-container space-between p-l-8 p-r-8">
                                <p className="flex-item">{data.reps} Reps</p>
                                <div className="flex-item" style={{width:"1px", height:"70%", background:"#9a9a9a"}} />
                                <p className="flex-item">{data.weight.value} Kg</p>
                              </div>
                            </div>
                          )
                        }) 
                      }
                    </div>
                  </div>
                )
              }
              {
                workoutContent && workoutContent.optionalExercises[selectedOptionalExerciseIndex].fullContent && workoutContent.optionalExercises[selectedOptionalExerciseIndex].fullContent.primaryMuscles && workoutContent.optionalExercises[selectedOptionalExerciseIndex].fullContent.primaryMuscles.length > 0 && (
                  <>
                    <p className="flex-item font-weight-600 color-red m-b-8">Muscles</p>
                    <div className="d-flex-wrap">
                      {
                        workoutContent.optionalExercises[selectedOptionalExerciseIndex].fullContent.primaryMuscles.map(primaryMusclesInfo => {
                          return(
                            <div className="d-flex m-r-12 m-b-12" style={{background:"#6A1B9A", borderRadius:"8px"}}>
                              <p className="flex-item color-white font-weight-600" style={{padding:"4px 12px"}}>{primaryMusclesInfo.name}</p>
                            </div>
                          )
                        })
                      }
                      {
                        workoutContent.optionalExercises[selectedOptionalExerciseIndex].fullContent.secondaryMuscles && workoutContent.optionalExercises[selectedOptionalExerciseIndex].fullContent.secondaryMuscles.length > 0 && workoutContent.optionalExercises[selectedOptionalExerciseIndex].fullContent.secondaryMuscles.map(secondaryMusclesInfo => {
                          return(
                            <div className="d-flex m-r-12 m-b-12" style={{background:"#26A69A", borderRadius:"8px"}}>
                              <p className="flex-item color-white font-weight-600" style={{padding:"4px 12px"}}>{secondaryMusclesInfo.name}</p>
                            </div>
                          )
                        })
                      }
                    </div>
                  </>
                ) 
              }

              {
                workoutContent && workoutContent.optionalExercises[selectedOptionalExerciseIndex].fullContent.instructions && (
                  <div className="w-full">
                    <p className="font-weight-600 color-red">Instructions</p>
                    <p className="m-b-20">{workoutContent && workoutContent.optionalExercises[selectedOptionalExerciseIndex].fullContent.instructions ? workoutContent.optionalExercises[selectedOptionalExerciseIndex].fullContent.instructions : "No Instruction Found"}</p>
                  </div>
                )
              }
            </div>
          ) : (
            <div className="w-full">
              <div className="d-flex p-t-12 p-b-12 m-b-12 space-between" style={{borderBottom:"1px solid #e0e0e0"}}>
                <p className='fs-16 color-dark-blue font-weight-700 flex-item' style={{width:"60%"}}>{workoutContent && workoutContent.fullContent.videoList && workoutContent.fullContent.videoList[currentVideo] && workoutContent.fullContent.videoList[currentVideo].title}</p>
                {
                  workoutContent && workoutContent.fullContent && workoutContent.fullContent.videoList && workoutContent.fullContent.videoList.length > 1 && (
                    <div className="d-flex">
                      <div className="d-flex flex-item m-r-12" style={{background:"#9a9a9a", width:"30px", height:"30px", borderRadius:"100%"}}>
                        <svg className="flex-item margin-auto" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.22461 0.5L0.724609 6L6.22461 11" stroke="white" stroke-linecap="round"/>
                        </svg>
                      </div>
                      <div className="d-flex flex-item" style={{background:"#9a9a9a", width:"30px", height:"30px", borderRadius:"100%"}}>
                        <svg className="flex-item margin-auto" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.5 11L6 5.5L0.5 0.5" stroke="white" stroke-linecap="round"/>
                        </svg>
                      </div>
                    </div>
                  )
                }
              </div>
              {
                workoutContent  && workoutContent.parameter && workoutContent.parameter.set && workoutContent.parameter.set.length > 0 && (
                  <div className="w-full">
                    <p className="flex-item font-weight-600 color-red m-b-8">Set/Reps</p>
                    <div className="d-flex-wrap space-between">
                      {
                        workoutContent.parameter.set.map((data,index) => {
                          return(
                            <div className="planner-set-reps-container d-flex m-b-12">
                              <div className="d-flex planner-set-container p-l-12 p-r-12 h-full">
                                <p className="flex-item color-white">Set {index + 1}</p>
                              </div>
                              <div className="d-flex planner-reps-container space-between p-l-8 p-r-8">
                                <p className="flex-item">{data.reps} Reps</p>
                                <div className="flex-item" style={{width:"1px", height:"70%", background:"#9a9a9a"}} />
                                <p className="flex-item">{data.weight.value} Kg</p>
                              </div>
                            </div>
                          )
                        }) 
                      }
                    </div>
                  </div>
                )
              }
              {
                workoutContent && workoutContent.fullContent && workoutContent.fullContent && workoutContent.fullContent.primaryMuscles && workoutContent.fullContent.primaryMuscles.length > 0 && (
                  <>
                    <p className="flex-item font-weight-600 color-red m-b-8">Muscles</p>
                    <div className="d-flex-wrap">
                      {
                        workoutContent.fullContent.primaryMuscles.map(primaryMusclesInfo => {
                          return(
                            <div className="d-flex m-r-12 m-b-12" style={{background:"#6A1B9A", borderRadius:"8px"}}>
                              <p className="flex-item color-white font-weight-600" style={{padding:"4px 12px"}}>{primaryMusclesInfo.name}</p>
                            </div>
                          )
                        })
                      }
                      {
                        workoutContent.fullContent.secondaryMuscles && workoutContent.fullContent.secondaryMuscles.length > 0 && workoutContent.fullContent.secondaryMuscles.map(secondaryMusclesInfo => {
                          return(
                            <div className="d-flex m-r-12 m-b-12" style={{background:"#26A69A", borderRadius:"8px"}}>
                              <p className="flex-item color-white font-weight-600" style={{padding:"4px 12px"}}>{secondaryMusclesInfo.name}</p>
                            </div>
                          )
                        })
                      }
                      {/* {
                        workoutContent.fullContent.secondaryMuscles.map(secondaryMusclesInfo => {
                          return(
                            <div className="d-flex m-r-12 m-b-12">
                              
                            </div>
                          )
                        }
                      } */}
                    </div>
                  </>
                ) 
              }
              {
                workoutContent && workoutContent.fullContent.instructions && (
                  <div className="w-full">
                    <p className="font-weight-600 color-red">Instructions</p>
                    <p className="m-b-20">{workoutContent && workoutContent.fullContent.instructions ? workoutContent.fullContent.instructions : "No Instruction Found"}</p>
                  </div>
                )
              }
            </div>
          )
        }

        {
          workoutContent && workoutContent.optionalExercises && workoutContent.optionalExercises.length > 0 && (
            <div className="d-flex w-full" style={{justifyContent:"center"}}>
                {
                  isOptionalContentEnabled ? (
                    <div className="d-flex" style={{position:"absolute", bottom: 0, marginBottom:"70px", transition:"180ms"}}>
                      {
                        workoutContent.optionalExercises.map((data, index) => {
                          return(
                            <div onClick={()=>handleSelectOptionalExerciseIndex(index)} className="flex-item d-flex m-r-8" style={{width:"50px", height:"50px", boxShadow:"0px 0px 6px rgba(0, 0, 0, 0.25)", background: index == selectedOptionalExerciseIndex ? "var(--darkBlue)" : "#ffffff", borderRadius:"100%"}}>
                              <p className="flex-item fs-12 font-weight-700 margin-auto" style={{color: index == selectedOptionalExerciseIndex ? "#ffffff" : "var(--darkBlue)"}}>OP {index+ 1}</p>
                            </div> 
                          )  
                        })
                      }

                      <div onClick={()=>toggleOptionalContentView()} className="flex-item d-flex m-l-12" style={{width:"50px", height:"50px", boxShadow:"0px 0px 6px rgba(0, 0, 0, 0.25)", background:"var(--red)", borderRadius:"100%"}}>
                        <svg className="flex-item margin-auto" width="22" height="22" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.43357 0.233926C1.2764 0.0821281 1.0659 -0.00186718 0.847406 3.15022e-05C0.628908 0.00193018 0.419898 0.0895712 0.265391 0.244078C0.110885 0.398585 0.0232436 0.607595 0.0213449 0.826092C0.0194462 1.04459 0.103441 1.25509 0.25524 1.41226L5.06774 6.22476L0.254407 11.0373C0.174815 11.1141 0.111329 11.2061 0.0676553 11.3078C0.0239812 11.4094 0.000992978 11.5188 3.14642e-05 11.6294C-0.000930049 11.7401 0.0201545 11.8498 0.0620553 11.9522C0.103956 12.0546 0.165834 12.1477 0.244078 12.2259C0.322321 12.3042 0.415365 12.366 0.517778 12.4079C0.620192 12.4498 0.729925 12.4709 0.840574 12.47C0.951224 12.469 1.06057 12.446 1.16224 12.4023C1.26391 12.3587 1.35587 12.2952 1.43274 12.2156L6.24607 7.40309L11.0586 12.2156C11.2157 12.3674 11.4262 12.4514 11.6447 12.4495C11.8632 12.4476 12.0722 12.3599 12.2268 12.2054C12.3813 12.0509 12.4689 11.8419 12.4708 11.6234C12.4727 11.4049 12.3887 11.1944 12.2369 11.0373L7.42441 6.22476L12.2369 1.41226C12.3887 1.25509 12.4727 1.04459 12.4708 0.826092C12.4689 0.607595 12.3813 0.398585 12.2268 0.244078C12.0722 0.0895712 11.8632 0.00193018 11.6447 3.15022e-05C11.4262 -0.00186718 11.2157 0.0821281 11.0586 0.233926L6.24607 5.04643L1.43357 0.233093V0.233926Z" fill="#ffffff"/>
                        </svg>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex space-between p-l-12 p-r-12" style={{width:"auto", height:"30px", position:"absolute", bottom: 0, boxShadow:"0px 0px 8px rgba(0, 0, 0, 0.25)", borderRadius:"15px", marginBottom:"70px", transition:"180ms", background:"#ffffff"}}>
                      <div onClick={()=>toggleOptionalContentView()} className="flex-item w-full d-flex">
                        <p className="flex-item fs-14 font-weight-700 color-dark-blue margin-auto">{workoutContent.optionalExercises.length} Optional Exercise</p>
                      </div>
                    </div>
                  )
                }
                {/* <div className="d-flex">
                  <div className="d-flex flex-item m-r-12" style={{background:"#9a9a9a", width:"30px", height:"30px", borderRadius:"100%"}}>
                    <svg className="flex-item margin-auto" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.22461 0.5L0.724609 6L6.22461 11" stroke="white" stroke-linecap="round"/>
                    </svg>
                  </div>
                  <div className="d-flex flex-item" style={{background:"#9a9a9a", width:"30px", height:"30px", borderRadius:"100%"}}>
                    <svg className="flex-item margin-auto" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.5 11L6 5.5L0.5 0.5" stroke="white" stroke-linecap="round"/>
                    </svg>
                  </div>
                </div> */}
              
            </div>
          ) 
        }
      </div>
    </div>
  )
}

export default PlannerExerciseView;